import { render } from "./bulk-product-upload.vue?vue&type=template&id=d28294c0&scoped=true"
import script from "./bulk-product-upload.vue?vue&type=script&lang=js"
export * from "./bulk-product-upload.vue?vue&type=script&lang=js"

import "./bulk-product-upload.vue?vue&type=style&index=0&id=d28294c0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28294c0"]])

export default __exports__